import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import ReactDOM from "react-dom";
import { twMerge } from "tailwind-merge";

interface DeleteConfirmationProps {
  message: string;
  onClickYes: () => void;
  onClickNo: () => void;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({ message, onClickYes, onClickNo }) => {
  const theme = useAtomValue(themeAtom);

  return ReactDOM.createPortal(
    <div
      className={twMerge(
        "fixed inset-0 z-50 flex items-center justify-center bg-opacity-40 backdrop-blur-sm",
        theme.home.tailwind.pageBackground,
      )}
      onClick={onClickNo}
    >
      <div
        id="alert-box"
        className={twMerge(
          "z-50 flex h-[150px] w-[350px] flex-col justify-between rounded-xl border px-4 py-4 shadow-xl",
          theme.uwhcAssistant.border,
          theme.home.tailwind.panelBackground,
          theme.home.tailwind.textDefault,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={twMerge("ml-4 mt-4 text-left text-[14px]", theme.uwhcAssistant.textOutput)}>{message}</div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClickYes}
            className={twMerge(
              "mb-3 mr-3 h-[36px] w-[60px] flex-shrink-0 rounded border text-[14px] focus:outline-none focus:ring",
              theme.uwhcAssistant.sendBorder,
              theme.uwhcAssistant.chatBg,
              theme.headerComponent.tailwind.buttonText,
              theme.headerComponent.tailwind.buttonHoverBg,
              theme.headerComponent.tailwind.buttonHoverText,
              theme.headerComponent.tailwind.buttonFocusRing,
            )}
          >
            Yes
          </button>
          <button
            type="button"
            onClick={onClickNo}
            className={twMerge(
              "mb-3 mr-3 h-[36px] w-[60px] flex-shrink-0 rounded border text-[14px] focus:outline-none focus:ring",
              theme.uwhcAssistant.sendBorder,
              theme.uwhcAssistant.chatBg,
              theme.headerComponent.tailwind.buttonText,
              theme.headerComponent.tailwind.buttonHoverBg,
              theme.headerComponent.tailwind.buttonHoverText,
              theme.headerComponent.tailwind.buttonFocusRing,
            )}
          >
            No
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default DeleteConfirmation;
